import { gql, TypedDocumentNode } from '@common/hooks';

type HourEntryType = {
  id: string;
  startedAt?: string;
  startedAtTz?: string;
  endedAt?: string;
  endedAtTz?: string;
};

export const HourEntry: TypedDocumentNode<HourEntryType> = gql`
  fragment HourEntry on WorksTimekeepingHourEntry {
    id
    startedAt
    startedAtTz
    endedAt
    endedAtTz
  }
`;
